import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DropdownOption } from '@maced/angular-components/lib/dropdown/dropdown.model';
import { Placement } from '@popperjs/core';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-grading-card',
  templateUrl: './grading-card.component.html'
})
export class GradingCardComponent {
  hasTitleName = true  as boolean;
  hasGradeButton = true as boolean;
  hasMoreActions = true as boolean;
  hasDate = true as boolean;
  hasMetaData = true as boolean;
  hasLableIcon = true as boolean;
  hasTooltip = true as boolean;
  hasPreviousAttempts = true as boolean;
  label = 'Item Title' as string;
  sizeList = ['small', 'large'];
  statusList = ['default', 'primary', 'success', 'warning', 'danger', 'normal', 'active'];
  selectedSize = 'small';
  selectedStatus = 'danger';
  hasOutline = true;
  hasStatusIcon = false;
  ariaLabel = 'Chips';
  hasContentBelow = true;
  hasIconLeftSide = true;
  hasActions = true;
  hasDefaultExpanded = true;
  collapseLabel = 'Collapse';
  expandLabel = 'Expand';
  collapseLabel1 = 'Hide previous attempts';
  expandLabel1 = 'Show previous attempts';
  selectedPlacement: Placement = 'auto';
  selectedLanguage: string = 'English';
  hasCaret: boolean = true;
  message: string = 'Status Icon';
  color = 'primary' as string;
  isBrowser = true as boolean;
  metaData = ['Course name','Course name','Course name'];
  isMobileView = false as boolean;
  isDesktopView = true as boolean;
  previousAttemptsData = [
    { 
      cardId: 'sampleCard',
      buttonId: 'buttonId',
      Attempts: '1/1',
      Attempted: '01 January 2023, 9:00 AM',
      Score: '1/01',
      GradedBy: 'Name'
    },
    {
      cardId: 'sampleCard1',
      buttonId: 'buttonId1',
      Attempts: '1/2',
      Attempted: '02 January 2023, 9:00 AM',
      Score: '1/9',
      GradedBy: 'Name1'
    },
    {
      cardId: 'sampleCard2',
      buttonId: 'buttonId2',
      Attempts: '1/3',
      Attempted: '03 January 2023, 9:00 AM',
      Score: '1/8',
      GradedBy: 'Name2'
    },
    {
      cardId: 'sampleCard3',
      buttonId: 'buttonId3',
      Attempts: '1/4',
      Attempted: '04 January 2023, 9:00 AM',
      Score: '1/7',
      GradedBy: 'Name3'
    },
    {
      cardId: 'sampleCard4',
      buttonId: 'buttonId4',
      Attempts: '1/5',
      Attempted: '05 January 2023, 9:00 AM',
      Score: '1/6',
      GradedBy: 'Name4'
    }
  ]
  options4: DropdownOption[] = [
    {
      id: 'option41',
      name: 'option41',
      label: 'option 41',
      url: '/gradingCard'
    },
    {
      id: 'option42',
      name: 'option42',
      label: 'option 42',
      url: '/gradingCard'
    },
    {
      id: 'option43',
      name: 'option43',
      label: 'option 43',
      url: '/gradingCard'
    }
  ];
  selectedOptions4!: DropdownOption;
  private queryParamSubscription!: Subscription;
  isMobile: boolean = false;
  constructor(@Inject(PLATFORM_ID) public platformId:object,private route: ActivatedRoute,) {
    if (isPlatformBrowser(this.platformId)) {
      this.isBrowser = true;
    } else{
      this.isBrowser = false;
    }
    this.queryParamSubscription = this.route.queryParams.subscribe(param => {
      if (param.dropdownId && (param.dropdownId === 'dropdownId4' || param.dropdownId === 'dropdownId2')) {
        this.options4.forEach((obj) => {
          if (obj.id === param.selectedDropdownOptionId) {
            obj.active = true;
            this.selectedOptions4 = obj;
          } else {
            obj.active = false;
          }
        });
      }
    });
   }
  @HostListener('window:resize', ['$event'])
  onResize() {
    if (isPlatformBrowser(this.platformId)) {
      if (window.innerWidth < 768) {
        this.isMobile = true;
        this.isMobileView = true;
        this.isDesktopView = false;
      } else{
        this.isMobile = false;
        this.isMobileView = false;
        this.isDesktopView = true;
      }
    }
  }
  ngOnInit(): void {
    this.onResize();
  }
}